import { Controller } from "@hotwired/stimulus";

const SIGNER_COLORS = [
  { border: "#0d6efd", bg: "rgba(13, 110, 253, 0.1)", label: "#0d6efd" },
  { border: "#198754", bg: "rgba(25, 135, 84, 0.1)", label: "#198754" },
  { border: "#dc3545", bg: "rgba(220, 53, 69, 0.1)", label: "#dc3545" },
  { border: "#fd7e14", bg: "rgba(253, 126, 20, 0.1)", label: "#fd7e14" },
  { border: "#6f42c1", bg: "rgba(111, 66, 193, 0.1)", label: "#6f42c1" },
  { border: "#20c997", bg: "rgba(32, 201, 151, 0.1)", label: "#20c997" },
];

export { SIGNER_COLORS };

export default class extends Controller {
  static targets = ["list", "template", "counter"];
  static outlets = ["signature-field-placement"];

  connect() {
    this.index = this.listTarget.querySelectorAll(".signer-row").length;
    this.updateColorBadges();
    this.syncSignerCount();
  }

  add(event) {
    event.preventDefault();
    const fragment = this.templateTarget.content.cloneNode(true);
    const wrapper = document.createElement("div");
    wrapper.appendChild(fragment);
    const html = wrapper.innerHTML.replace(/NEW_INDEX/g, this.index);
    this.listTarget.insertAdjacentHTML("beforeend", html);
    this.index++;
    this.syncSignerCount();
    this.updateColorBadges();
  }

  remove(event) {
    event.preventDefault();
    const row = event.target.closest(".signer-row");
    if (this.listTarget.querySelectorAll(".signer-row").length <= 1) return;

    const destroyInput = row.querySelector("input[name*='_destroy']");
    if (destroyInput) {
      destroyInput.value = "1";
      row.style.display = "none";
    } else {
      row.remove();
    }
    this.syncSignerCount();
    this.updateColorBadges();
  }

  syncSignerCount() {
    const visibleRows = this.listTarget.querySelectorAll(
      ".signer-row:not([style*='display: none'])",
    );
    const count = visibleRows.length;

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${count} signer${count !== 1 ? "s" : ""}`;
    }

    if (this.hasSignatureFieldPlacementOutlet) {
      this.signatureFieldPlacementOutlet.signerCountValue = count;
      this.signatureFieldPlacementOutlet.renderFields();
    }
  }

  updateColorBadges() {
    const rows = this.listTarget.querySelectorAll(
      ".signer-row:not([style*='display: none'])",
    );
    rows.forEach((row, idx) => {
      const badge = row.querySelector(".signer-color-badge");
      if (badge) {
        const color = SIGNER_COLORS[idx % SIGNER_COLORS.length];
        badge.style.backgroundColor = color.border;
      }
    });
  }
}
